export type LegacyBiblOption = {
  value: string;
  label: string;
};

export const legacyBiblFnaConfig = {
  options: {
    timePeriodOptions: [
      { value: "A", label: "少於1年" },
      { value: "B", label: "1-5年" },
      { value: "C", label: "6-10年" },
      { value: "D", label: "11-15年" },
      { value: "E", label: "16-20年" },
      { value: "F", label: "超過20年" },
      { value: "G", label: "終身" },
    ] satisfies LegacyBiblOption[],
    premiumPeriodOptions: [
      { value: "A", label: "2-5年" },
      { value: "B", label: "6-10年" },
      { value: "C", label: "11-15年" },
      { value: "D", label: "16-20年" },
      { value: "E", label: "超過20年" },
      { value: "F", label: "終身" },
      { value: "G", label: "一次性付款不超過" },
    ] satisfies LegacyBiblOption[],
    incomeRatioOptions: [
      { value: "A", label: "少於10%" },
      { value: "B", label: "10%-20%" },
      { value: "C", label: "21%-30%" },
      { value: "D", label: "31%-40%" },
      { value: "E", label: "41%-50%" },
      { value: "F", label: "超過50%" },
      { value: "G", label: "不適用" },
    ] satisfies LegacyBiblOption[],
    investmentWithdrawalOptions: [
      { value: "A", label: "20年後" },
      { value: "B", label: "十至二十年內" },
      { value: "C", label: "五至十年內" },
      { value: "D", label: "五年內但現在不提取" },
      { value: "E", label: "立即提取" },
    ] satisfies LegacyBiblOption[],
    investmentGoalOptions: [
      { value: "A", label: "積極增長" },
      { value: "B", label: "顯著增長" },
      { value: "C", label: "適度增長" },
      { value: "D", label: "輕微增長" },
      { value: "E", label: "避免虧損" },
    ] satisfies LegacyBiblOption[],
    investmentExpectationOptions: [
      { value: "A", label: "虧損" },
      { value: "B", label: "微小收益或無收益" },
      { value: "C", label: "小幅收益" },
      { value: "D", label: "適度收益" },
      { value: "E", label: "輕微受市場影響" },
    ] satisfies LegacyBiblOption[],
    contributionReasonOptions: [
      { value: "A", label: "保費會根據退休時的實際需要，由退休儲蓄金支付。" },
      { value: "B", label: "其他" },
    ] satisfies LegacyBiblOption[],
  },
  edit: {
    investmentManagement: {
      label:
        "1.E.1 如在問題1中選擇(答案E)「投資」作為目標之一，為實現上述「保險產品」的目標，閣下希望如何管理保險產品項目下的不同投資選項 / 投資選擇（如有）？（勾選一項）。",
      validationMessage:
        "請回答：為實現上述「E.投資」的目標，閣下希望如何管理保險產品項目下的不同投資選項 / 投資選擇。 ",
      options: [
        {
          value: "A",
          label:
            "本人願意按個人決定選擇及管理保險產品項下的不同投資選項/投資選擇（如有），並且願意在保險產品的目標利益/保障期的整個期間作出此決定。（若選擇此項，必須要回答問題1.E.1.1、1.E.1.2、1.E.1.3）",
        },
        {
          value: "B",
          label:
            "本人不願意選擇或管理保險產品項下的不同投資選項/投資選擇（如有）。",
        },
      ] satisfies LegacyBiblOption[],
      nestedVisibleValue: "A",
      withdrawalLabel: "1.E.1.1 閣下計劃何時開始提取閣下的投資？(勾選一項)。",
      longTermGoalLabel: "1.E.1.2 閣下對這項投資的長期目標是什麼？(勾選一項)。",
      expectationLabel:
        "1.E.1.3 如果未來10年股市表現不佳，閣下對這項投資的期望是什麼？（勾選一項）。",
    },
  },
  detail: {
    investmentManagement: {
      label:
        "1.E.1 閣下希望如何管理保險產品項目下的不同投資選項 / 投資選擇（如有）？（勾選一項）。",
      options: [
        {
          value: "A",
          label:
            "本人願意按個人決定選擇及管理保險產品項下的不同投資選項/投資選擇（如有），並且願意在保險產品的目標利益/保障期的整個期間作出此決定。",
        },
        {
          value: "B",
          label:
            "本人不願意選擇或管理保險產品項下的不同投資選項/投資選擇（如有）。",
        },
      ] satisfies LegacyBiblOption[],
      nestedVisibleValue: "A",
      withdrawalLabel: "1.E.1.1 閣下計劃何時開始提取閣下的投資？(勾選一項)。",
      longTermGoalLabel: "1.E.1.2 閣下希望此保險產品能達致什麼長遠目標？(勾選一項)。",
      expectationLabel: "1.E.1.3 假設投資市場表現欠佳，閣下預期投資回報會是？(勾選一項)。",
    },
  },
} as const;
